import React from 'react';

import Label from '../Label/Label';
import Input from '../Input/Input';
import Description from '../Description/Description';

import styles from './JsonField.module.css';
import { formatJson } from '../../../common/utils';

const JsonField = ({
    field,
    changed,
    disabled = false,
    placeholder = '',
    children = null,
    style = {},
    showName = true,
    inputStyle = {},
    errorStyle = {}
}) => {
    const blurHandler = () => {
        const newValue = formatJson(field.value);
        changed(field.id, newValue);
    };

    return (
        <div className={styles.textInput} style={style}>
            {showName && <Label value={field.name} />}
            <div className={styles.fieldsContainer}>
                <Input
                    {...field}
                    disabled={disabled}
                    style={{ maxWidth: '700px' }}
                    type="textarea"
                    placeholder={placeholder}
                    rows="5"
                    changed={changed}
                    blurred={blurHandler}
                    inputStyle={inputStyle}
                    errorStyle={errorStyle}
                />
                {children && <span className={styles.buttons}>{children}</span>}
            </div>
            {field.desc && <Description value={field.desc} />}
        </div>
    );
};

export default React.memo(JsonField);
